import { formValidationOptions } from 'modules/billing/TemporaryFund/configs/temporaryFundConfigs';
import { showFormErrorMessage } from 'modules/billing/TemporaryFund/helpers/temporaryFundHelpers';
import { InputNumber } from 'primereact/inputnumber';
import React from 'react';
import { Controller } from 'react-hook-form';

const TemporaryFundAmountV2 = (props) => {
  const { control, errors, temporaryFundBalance, isWithdraw, runningTrustBalance, paymentMethod } = props;

  // Custom validation function to check if withdraw amount exceeds balance
  const validateAmount = (value) => {
    if (value === null || value === undefined || value === '') {
      return true;
    }

    const amount = typeof value === 'number' ? value : parseFloat(value);
    if (isNaN(amount)) return true;

    if (amount === 0 || amount <= 0) {
      return 'Amount must be greater than 0';
    }

    const isChequeDeposit = !isWithdraw && paymentMethod === 'cheque_payment';

    // Skip running trust balance validation for withdrawals and cheque deposits
    if (!isChequeDeposit && !isWithdraw) {
      const runningBalance = typeof runningTrustBalance === 'number' ? runningTrustBalance : parseFloat(runningTrustBalance) || 0;
      if (runningBalance === 0) {
        return 'Running trust balance is $0';
      }

      if (!isNaN(runningBalance) && amount > runningBalance && paymentMethod === 'transfer_from_trust_account') {
        return `Amount cannot exceed running trust balance`;
      }
    }

    if (isWithdraw && temporaryFundBalance !== undefined && temporaryFundBalance !== null) {
      const balance = typeof temporaryFundBalance === 'number' ? temporaryFundBalance : parseFloat(temporaryFundBalance) || 0;
      if (!isNaN(balance) && amount > balance) {
        return `Amount cannot exceed temporary fund balance`;
      }
    }
    return true;
  };
  return (
    <div className="d-flex align-items-top py-2 flex-wrap">
      <div className="col-12 col-sm-4 pt-2">
        Amount<span className="alert-star">*</span>
      </div>
      <div className="col-12 col-sm-8">
        <Controller
          control={control}
          name={formValidationOptions?.amount?.name}
          rules={{
            ...formValidationOptions?.amount?.rules,
            validate: validateAmount,
          }}
          render={({ field }) => (
            <InputNumber
              // onValueChange={(e) => {}}
              name={field?.name}
              value={field?.value}
              onValueChange={(e) => field?.onChange(e)}
              // onChange={(e) => field.onChange(e.value)}

              className="input-shadow w-100"
              mode="currency"
              currency="USD"
              locale="en-US"
              placeholder="Type in"
            />
          )}
        />
        {showFormErrorMessage(formValidationOptions?.amount?.name, errors)}
      </div>
    </div>
  );
};

export default TemporaryFundAmountV2;
